module.exports = "https://trybtryb-legacy.web.app/img/to_top_right.24fbfc25.svg";